// importing stylesheets in `/stylesheets/index.scss`
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';

Vue.use(BootstrapVue);
